import React, { useState, useMemo } from 'react';

const categories = [
  { value: 'clothes', label: 'Одежда и обувь', multiplier: 2.6 },
  { value: 'electronics', label: 'Электроника', multiplier: 2.2 },
  { value: 'home', label: 'Товары для дома', multiplier: 2.8 },
  { value: 'cosmetics', label: 'Косметика', multiplier: 3.0 },
  { value: 'food', label: 'Продукты питания', multiplier: 2.4 },
  { value: 'kids', label: 'Детские товары', multiplier: 2.5 },
  { value: 'other', label: 'Другое', multiplier: 2.3 },
];

const CalculatorSection = () => {
  const [revenue, setRevenue] = useState(2000000);
  const [drr, setDrr] = useState(25);
  const [category, setCategory] = useState('clothes');

  const results = useMemo(() => {
    const cat = categories.find(c => c.value === category);
    const multiplier = cat?.multiplier || 2.3;

    const newRevenue = revenue * multiplier;
    const newDrr = Math.max(5, Math.round(drr * 0.28));
    const profitIncrease = Math.round((newRevenue - revenue) * 0.35);
    const revenueGrowth = Math.round(((newRevenue - revenue) / revenue) * 100);
    const roi = Math.round((profitIncrease / 150000) * 100);

    return { newRevenue, newDrr, profitIncrease, revenueGrowth, roi };
  }, [revenue, drr, category]);

  const formatMoney = (value) => {
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(1)} млн ₽`;
    }
    return `${(value / 1000).toFixed(0)} тыс ₽`;
  };

  const getSliderFill = (value, min, max) => {
    return ((value - min) / (max - min)) * 100;
  };

  const benefits = [
    'Бесплатный расчёт',
    'За 3 минуты',
    'Без обязательств',
  ];

  return (
    <section
      id="pricing"
      className="calculator-section"
      style={{
        background: '#0F0F1A',
        padding: '40px 0 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные иконки на фоне */}
      <div
        className="calculator-decor"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 0,
        }}
      >
        <img
                loading="lazy"
          src="/images/icons/coins.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '90px',
            height: '90px',
            top: '10%',
            left: '3%',
            transform: 'rotate(-12deg)',
            opacity: 0.06,
            filter: 'blur(2px) brightness(2)',
            animation: 'floatCalc1 6s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/chart.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '85px',
            height: '85px',
            top: '15%',
            right: '4%',
            transform: 'rotate(10deg)',
            opacity: 0.06,
            filter: 'blur(2px) brightness(2)',
            animation: 'floatCalc2 7s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/wallet.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '80px',
            height: '80px',
            bottom: '20%',
            left: '5%',
            transform: 'rotate(8deg)',
            opacity: 0.06,
            filter: 'blur(2px) brightness(2)',
            animation: 'floatCalc3 5.5s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/star.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '75px',
            height: '75px',
            bottom: '25%',
            right: '3%',
            transform: 'rotate(-10deg)',
            opacity: 0.06,
            filter: 'blur(2px) brightness(2)',
            animation: 'floatCalc4 6.5s ease-in-out infinite',
          }}
        />
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 2,
        }}
      >
        <div
          className="calculator-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '60px',
            alignItems: 'flex-start',
          }}
        >
          {/* Левая колонка - УТП */}
          <div
            style={{
              alignSelf: 'flex-start',
            }}
          >
            <span
              style={{
                display: 'inline-block',
                background: 'rgba(255, 255, 255, 0.1)',
                color: '#FFFFFF',
                fontSize: '14px',
                fontWeight: 500,
                padding: '12px 24px',
                borderRadius: '50px',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                marginBottom: '24px',
              }}
            >
              КАЛЬКУЛЯТОР
            </span>

            <h2
              className="calculator-title"
              style={{
                fontSize: '46px',
                fontWeight: 800,
                color: '#FFFFFF',
                textTransform: 'uppercase',
                lineHeight: 1.1,
                margin: '0 0 32px 0',
              }}
            >
              УЗНАЙТЕ СКОЛЬКО
              <br />
              ВЫ МОЖЕТЕ
              <br />
              <span
                style={{
                  background: 'linear-gradient(90deg, #22D3EE 0%, #EC4899 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                ЗАРАБОТАТЬ
              </span>
            </h2>

            <ul
              style={{
                listStyle: 'none',
                padding: 0,
                margin: '0 0 32px 0',
              }}
            >
              {benefits.map((benefit, index) => (
                <li
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    fontSize: '16px',
                    fontWeight: 500,
                    color: '#FFFFFF',
                    marginBottom: '12px',
                  }}
                >
                  <span
                    style={{
                      width: '24px',
                      height: '24px',
                      background: 'linear-gradient(135deg, #22D3EE, #8B5CF6)',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '12px',
                      color: '#FFFFFF',
                    }}
                  >
                    ✓
                  </span>
                  {benefit}
                </li>
              ))}
            </ul>

            <div>
              <p
                style={{
                  fontSize: '15px',
                  fontWeight: 400,
                  color: 'rgba(255, 255, 255, 0.7)',
                  lineHeight: 1.6,
                  margin: '0 0 16px 0',
                }}
              >
                Проверьте насколько изменится Ваша прибыль в зависимости от категории которую Вы представляете. Основным способом роста продаж является управление конверсиями в первую очередь. Именно этим мы и займемся что приведет к снижению расходов на рекламу, а также сокращение ненужных поборов со стороны маркетплейса.
              </p>
              <p
                style={{
                  fontSize: '13px',
                  fontWeight: 400,
                  color: 'rgba(255, 255, 255, 0.4)',
                  lineHeight: 1.5,
                  margin: 0,
                  fontStyle: 'italic',
                }}
              >
                *цифры являются приблизительными и отражают среднюю статистику по клиентам агенства Первый Селлер
              </p>
            </div>

            {/* Декоративная иконка */}
            <div
              style={{
                position: 'absolute',
                bottom: '-40px',
                right: 0,
                opacity: 0.1,
              }}
            >
              <img
                loading="lazy"
                src="/images/icons/trophy.webp"
                alt=""
                style={{
                  width: '180px',
                  height: '180px',
                  objectFit: 'contain',
                  animation: 'iconFloat 3s ease-in-out infinite',
                }}
              />
            </div>
          </div>

          {/* Правая колонка - Калькулятор */}
          <div>
            <div
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '24px',
                padding: '24px',
              }}
            >
              {/* Заголовок карточки */}
              <div
                style={{
                  marginBottom: '20px',
                }}
              >
                <span
                  style={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: '#FFFFFF',
                    textTransform: 'uppercase',
                  }}
                >
                  РАССЧИТАЙТЕ ВАШУ ВЫГОДУ
                </span>
              </div>

              {/* Слайдер: Выручка */}
              <div style={{ marginBottom: '16px' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '8px',
                  }}
                >
                  <label
                    style={{
                      fontSize: '14px',
                      fontWeight: 500,
                      color: 'rgba(255, 255, 255, 0.6)',
                    }}
                  >
                    Текущая выручка в месяц
                  </label>
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: 600,
                      color: '#FFFFFF',
                    }}
                  >
                    {formatMoney(revenue)}
                  </span>
                </div>
                <div
                  style={{
                    position: 'relative',
                    height: '8px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '4px',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      height: '100%',
                      width: `${getSliderFill(revenue, 500000, 10000000)}%`,
                      background: 'linear-gradient(90deg, #22D3EE 0%, #8B5CF6 50%, #EC4899 100%)',
                      borderRadius: '4px',
                    }}
                  />
                  <input
                    type="range"
                    min="500000"
                    max="10000000"
                    step="100000"
                    value={revenue}
                    onChange={(e) => setRevenue(Number(e.target.value))}
                    aria-label="Выручка в месяц"
                    style={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      opacity: 0,
                      cursor: 'pointer',
                      zIndex: 2,
                    }}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '8px',
                    fontSize: '12px',
                    color: 'rgba(255, 255, 255, 0.4)',
                  }}
                >
                  <span>500 тыс</span>
                  <span>10 млн</span>
                </div>
              </div>

              {/* Слайдер: ДРР */}
              <div style={{ marginBottom: '16px' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '8px',
                  }}
                >
                  <label
                    style={{
                      fontSize: '14px',
                      fontWeight: 500,
                      color: 'rgba(255, 255, 255, 0.6)',
                    }}
                  >
                    Текущий ДРР
                  </label>
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: 600,
                      color: '#FFFFFF',
                    }}
                  >
                    {drr}%
                  </span>
                </div>
                <div
                  style={{
                    position: 'relative',
                    height: '8px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '4px',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      height: '100%',
                      width: `${getSliderFill(drr, 5, 50)}%`,
                      background: 'linear-gradient(90deg, #22D3EE 0%, #8B5CF6 50%, #EC4899 100%)',
                      borderRadius: '4px',
                    }}
                  />
                  <input
                    type="range"
                    min="5"
                    max="50"
                    step="1"
                    value={drr}
                    onChange={(e) => setDrr(Number(e.target.value))}
                    aria-label="Текущий ДРР"
                    style={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      opacity: 0,
                      cursor: 'pointer',
                      zIndex: 2,
                    }}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '8px',
                    fontSize: '12px',
                    color: 'rgba(255, 255, 255, 0.4)',
                  }}
                >
                  <span>5%</span>
                  <span>50%</span>
                </div>
              </div>

              {/* Select: Категория */}
              <div style={{ marginBottom: '16px' }}>
                <label
                  style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: 'rgba(255, 255, 255, 0.6)',
                    display: 'block',
                    marginBottom: '8px',
                  }}
                >
                  Категория товара
                </label>
                <select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  className="calculator-select"
                  aria-label="Категория товара"
                  style={{
                    width: '100%',
                    padding: '14px 40px 14px 16px',
                    background: 'rgba(255, 255, 255, 0.08)',
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    borderRadius: '12px',
                    color: '#FFFFFF',
                    fontSize: '15px',
                    fontWeight: 500,
                    cursor: 'pointer',
                    outline: 'none',
                    appearance: 'none',
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right 16px center',
                  }}
                >
                  {categories.map((cat) => (
                    <option
                      key={cat.value}
                      value={cat.value}
                    >
                      {cat.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Результаты */}
              <div
                style={{
                  background: 'linear-gradient(135deg, rgba(34, 211, 238, 0.1) 0%, rgba(139, 92, 246, 0.1) 50%, rgba(236, 72, 153, 0.1) 100%)',
                  border: '1px solid rgba(34, 211, 238, 0.2)',
                  borderRadius: '16px',
                  padding: '16px',
                  marginTop: '4px',
                }}
              >
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: 600,
                    color: 'rgba(255, 255, 255, 0.6)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    marginBottom: '12px',
                  }}
                >
                  ВАША ВЫГОДА ЗА 3 МЕСЯЦА:
                </div>

                <div
                  className="calculator-results-grid"
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '12px',
                  }}
                >
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <span style={{ fontSize: '20px', marginBottom: '4px' }}>📈</span>
                    <span
                      style={{
                        fontSize: '12px',
                        fontWeight: 400,
                        color: 'rgba(255, 255, 255, 0.5)',
                      }}
                    >
                      Рост выручки
                    </span>
                    <span
                      style={{
                        fontSize: '20px',
                        fontWeight: 700,
                        background: 'linear-gradient(90deg, #22D3EE 0%, #EC4899 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                      }}
                    >
                      +{results.revenueGrowth}%
                    </span>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <span style={{ fontSize: '20px', marginBottom: '4px' }}>📉</span>
                    <span
                      style={{
                        fontSize: '12px',
                        fontWeight: 400,
                        color: 'rgba(255, 255, 255, 0.5)',
                      }}
                    >
                      ДРР снизится до
                    </span>
                    <span
                      style={{
                        fontSize: '20px',
                        fontWeight: 700,
                        background: 'linear-gradient(90deg, #22D3EE 0%, #EC4899 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                      }}
                    >
                      {results.newDrr}%
                    </span>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <span style={{ fontSize: '20px', marginBottom: '4px' }}>💰</span>
                    <span
                      style={{
                        fontSize: '12px',
                        fontWeight: 400,
                        color: 'rgba(255, 255, 255, 0.5)',
                      }}
                    >
                      Доп. прибыль
                    </span>
                    <span
                      style={{
                        fontSize: '20px',
                        fontWeight: 700,
                        background: 'linear-gradient(90deg, #22D3EE 0%, #EC4899 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                      }}
                    >
                      +{formatMoney(results.profitIncrease)}
                    </span>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <span style={{ fontSize: '20px', marginBottom: '4px' }}>🎯</span>
                    <span
                      style={{
                        fontSize: '12px',
                        fontWeight: 400,
                        color: 'rgba(255, 255, 255, 0.5)',
                      }}
                    >
                      ROI
                    </span>
                    <span
                      style={{
                        fontSize: '20px',
                        fontWeight: 700,
                        background: 'linear-gradient(90deg, #22D3EE 0%, #EC4899 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                      }}
                    >
                      {results.roi}%
                    </span>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <button
                style={{
                  width: '100%',
                  background: 'linear-gradient(135deg, #F97316 0%, #EC4899 100%)',
                  border: 'none',
                  color: '#FFFFFF',
                  fontSize: '16px',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  padding: '16px 32px',
                  borderRadius: '50px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  marginTop: '16px',
                }}
                onClick={() => window.dispatchEvent(new Event('openModal'))}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.02)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(249, 115, 22, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                ПОЛУЧИТЬ ПОДРОБНЫЙ РАСЧЁТ →
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Адаптивные стили */}
      <style>
        {`
          /* Тонкая анимация для иконок */
          @keyframes iconFloat {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-5px); }
          }

          /* Анимации плавающих иконок на фоне */
          @keyframes floatCalc1 {
            0%, 100% { transform: translate(0, 0) rotate(-12deg); }
            50% { transform: translate(-10px, -12px) rotate(-12deg); }
          }

          @keyframes floatCalc2 {
            0%, 100% { transform: translate(0, 0) rotate(10deg); }
            50% { transform: translate(10px, -15px) rotate(10deg); }
          }

          @keyframes floatCalc3 {
            0%, 100% { transform: translate(0, 0) rotate(8deg); }
            50% { transform: translate(-12px, -10px) rotate(8deg); }
          }

          @keyframes floatCalc4 {
            0%, 100% { transform: translate(0, 0) rotate(-10deg); }
            50% { transform: translate(14px, -14px) rotate(-10deg); }
          }

          /* Белый фон для выпадающего списка */
          .calculator-select option {
            background: #FFFFFF !important;
            color: #0F0F1A !important;
            padding: 8px;
          }

          @media (max-width: 1024px) {
            .calculator-grid {
              grid-template-columns: 1fr !important;
              gap: 48px !important;
            }
            .calculator-decor { display: none !important; }
          }

          @media (max-width: 768px) {
            .calculator-title { font-size: 32px !important; }
            .calculator-results-grid {
              grid-template-columns: 1fr 1fr !important;
              gap: 12px !important;
            }
          }

          @media (max-width: 480px) {
            .calculator-title { font-size: 26px !important; }
            .calculator-results-grid {
              grid-template-columns: 1fr 1fr !important;
              gap: 10px !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default CalculatorSection;
